// extracted by css-extract-rspack-plugin
export default {"indicator":"_9b98c50e","option":"_e2750c6c"};